import { ARTIFACT_ID_PATTERN, ARTIFACT_KINDS, type ArtifactKind } from '@/services/artifact-vocabulary';
import type { Artifact, ArtifactRef } from '@/services/artifacts';

/**
 * ARTIFACT KEYS (the prototype's `kind:id`, the server's `artifactKeys.ts`): `brand_deal:12`, `deliverable:340`,
 * `contract:deal-12`, `negotiation:review-40`. Split at the first colon. Pure.
 */
export const isArtifactKind = (value: unknown): value is ArtifactKind => typeof value === 'string' && (ARTIFACT_KINDS as readonly string[]).includes(value);

export const artifactKey = (ref: ArtifactRef): string => `${ref.kind}:${ref.id}`;

export function parseArtifactKey(key: unknown): ArtifactRef | null {
  if (typeof key !== 'string') return null;
  const at = key.indexOf(':');
  if (at < 1) return null;
  const kind = key.slice(0, at);
  const id = key.slice(at + 1);
  return isArtifactKind(kind) && ARTIFACT_ID_PATTERN.test(id) ? { kind, id } : null;
}

/** Every artifact by its key and by each of its aliases (a tag made before the contract row or the case existed). */
export function indexArtifacts(list: readonly Artifact[]): Map<string, Artifact> {
  const byKey = new Map<string, Artifact>();
  for (const a of list) for (const alias of a.aliases) if (!byKey.has(alias)) byKey.set(alias, a);
  for (const a of list) byKey.set(a.key, a);
  return byKey;
}
